export const PAYMENT_STEP = "payment";
export const PASSWORD_STEP = "password";
export const PROFILE_STEP = "profile";
export const CONTACT_STEP = "contact";
export const EP_LANDING_STEP = "ep-landing";
export const EP_QUESTION_STEP = "ep-question";
export const COMPLETE_STEP = "complete";
export const ADDRESS_STEP = "address";
export const FREC_SHUTDOWN_STEP = "frec-shutdown-step";
